export default "__VITE_ASSET__BMVCEzhk__"